import useNavigator from "@saleor/hooks/useNavigator";
import { PageInfo, PaginationState } from "@saleor/hooks/usePaginator";
import { Pagination } from "@saleor/types";
import { stringifyQs } from "@saleor/utils/urls";

function usePaginatorRemittance() {
  const navigate = useNavigator();

  function paginate(
    pageInfoRemittance: PageInfo,
    paginationState: PaginationState,
    queryString: Pagination
  ) {
    const loadNextPageRemittance = () =>
      navigate(
        "?" +
          stringifyQs({
            ...queryString,
            after: pageInfoRemittance.endCursor,
            before: undefined
          }),
        true
      );

    const loadPreviousPageRemittance = () =>
      navigate(
        "?" +
          stringifyQs({
            ...queryString,
            after: undefined,
            before: pageInfoRemittance.startCursor
          }),
        true
      );

    const newPageInfo = pageInfoRemittance
      ? {
          ...pageInfoRemittance,
          hasNextPage:
            !!paginationState.before || pageInfoRemittance.hasNextPage,
          hasPreviousPage:
            !!paginationState.after || pageInfoRemittance.hasPreviousPage
        }
      : undefined;

    return {
      loadNextPageRemittance,
      loadPreviousPageRemittance,
      pageInfoRemittance: newPageInfo
    };
  }
  return paginate;
}
export default usePaginatorRemittance;
